import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import MenuPage from './pages/Menu';
import About from './pages/About';
import Contact from './pages/Contact';
import HalalRestaurantsNearMeBlog from './pages/blog/best-halal-restaurants-near-me';
import WhatIsHalalBlog from './pages/blog/what-is-halal-meaning';
// Catering page temporarily hidden from navigation and routing (kept on disk for later re-enable).
// import Catering from './pages/Catering';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog/best-halal-restaurants-near-me" element={<HalalRestaurantsNearMeBlog />} />
        <Route path="/blog/what-is-halal-meaning" element={<WhatIsHalalBlog />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}


/* injected: entrance-visibility failsafe — content must never stay invisible */
if (typeof window !== 'undefined') {
  var __hsReveal = function(){
    try {
      document.querySelectorAll('.reveal,.fade-in,.fade-up,[data-reveal],[data-aos]').forEach(function(el){ el.classList.add('in','visible','revealed','active','aos-animate'); });
      document.querySelectorAll('*').forEach(function(node){
        var el = node as HTMLElement;
        var cs = getComputedStyle(el);
        /* Closed scrims/drawers/sheets hide as opacity-0 + pointer-events-none. */
        /* Forcing THOSE visible dims+blurs the whole page (backdrop scrims) — */
        /* entrance-reveal content never carries pointer-events:none. */
        if (cs.pointerEvents === 'none') return;
        if (parseFloat(cs.opacity) < 0.05 && el.getClientRects().length) {
          el.style.setProperty('opacity','1','important');
          if (cs.transform && cs.transform !== 'none') el.style.setProperty('transform','none','important');
        }
      });
    } catch(e){}
  };
  window.addEventListener('load', function(){ setTimeout(__hsReveal, 1500); setTimeout(__hsReveal, 3500); });
}
